<form [formGroup]="newCourseForm" (ngSubmit)="saveCreatedCourse()">
  <div
    class="p-field required-field"
    [ngClass]="{
      'p-invalid':
        newCourseForm.get('courseName')?.invalid &&
        (newCourseForm.get('courseName')?.touched ||
          newCourseForm.get('courseName')?.dirty),
    }"
  >
    <p-floatLabel>
      <input
        id="courseName"
        type="text"
        pInputText
        formControlName="courseName"
      />
      <label for="courseName">Kursname*</label>
    </p-floatLabel>
  </div>

  <div class="p-field">
    <p-floatLabel>
      <p-dropdown
        inputId="timetableName"
        [options]="timetableNameOptions"
        formControlName="timetableName"
        [filter]="true"
        [showClear]="true"
        appendTo="body"
      />
      <label for="timetableName">Stundenplan-Name</label>
    </p-floatLabel>
    <small>Kursname aus dem Stundenplan.</small>
  </div>

  <div class="black-box">
    <h3 class="section-title">Kurszeitraum</h3>
    <div
      class="form-group required-field"
      [ngClass]="{
        'p-invalid':
          newCourseForm.get('startDate')?.invalid &&
          (newCourseForm.get('startDate')?.touched ||
            newCourseForm.get('startDate')?.dirty),
      }"
    >
      <p-floatLabel>
        <p-calendar
          inputId="startDate"
          formControlName="startDate"
          name="startDate"
          dateFormat="dd.mm.yy"
          showIcon="true"
        ></p-calendar>
        <label for="startDate">Startdatum*</label>
      </p-floatLabel>
    </div>

    <div class="form-group">
      <p-floatLabel>
        <p-calendar
          inputId="endDate"
          formControlName="endDate"
          name="endDate"
          dateFormat="dd.mm.yy"
          showIcon="true"
        ></p-calendar>
        <label for="endDate">Enddatum*</label>
      </p-floatLabel>
    </div>

    <div class="p-checkbox">
      <p-checkbox inputId="isActive" binary="true" formControlName="isActive" />
      <label for="isActive" class="checkbox-label">Aktiv</label>
    </div>
  </div>

  <div
    class="form-group required-field"
    appendTo="body"
    [ngClass]="{
      'p-invalid':
        newCourseForm.get('locationId')?.invalid &&
        (newCourseForm.get('locationId')?.touched ||
          newCourseForm.get('locationId')?.dirty),
    }"
  >
    <p-floatLabel>
      <p-dropdown
        [options]="locations"
        formControlName="locationId"
        optionLabel="locationName"
        optionValue="locationId"
      />
      <label for="locationId">Ort*</label>
    </p-floatLabel>
  </div>

  <div
    class="form-group required-field"
    appendTo="body"
    [ngClass]="{
      'p-invalid':
        newCourseForm.get('courseTypeId')?.invalid &&
        (newCourseForm.get('courseTypeId')?.touched ||
          newCourseForm.get('courseTypeId')?.dirty),
    }"
  >
    <p-floatLabel>
      <p-dropdown
        [options]="courseTypes"
        formControlName="courseTypeId"
        optionLabel="courseTypeName"
        optionValue="courseTypeId"
      />
      <label for="courseTypeId">Art des Kurses*</label>
    </p-floatLabel>
  </div>

  @if (canReadOccupations) {
  <div class="form-group">
    <p-floatLabel>
      <p-dropdown
        inputId="occupationId"
        [options]="occupations"
        formControlName="occupationId"
        optionLabel="name"
        optionValue="id"
        [showClear]="true"
      />
      <label for="occupationId">Ausbildungsberuf</label>
    </p-floatLabel>
  </div>
  }

  <div class="p-field">
    <p-floatLabel>
      <input id="ihk" type="text" pInputText formControlName="ihk" />
      <label for="ihk">Zuständige IHK</label>
    </p-floatLabel>
  </div>

  <div class="form-group">
    <p-floatLabel>
      <p-calendar
        inputId="apt1Date"
        formControlName="apt1Date"
        name="apt1Date"
        dateFormat="dd.mm.yy"
        showIcon="true"
      ></p-calendar>
      <label for="apt1Date">Termin APT1</label>
    </p-floatLabel>
  </div>

  <div class="form-group">
    <p-floatLabel>
      <p-calendar
        inputId="apt2Date"
        formControlName="apt2Date"
        name="apt2Date"
        dateFormat="dd.mm.yy"
        showIcon="true"
      ></p-calendar>
      <label for="apt2Date">Termin APT2</label>
    </p-floatLabel>
  </div>

  <div>
    <p>(* Pflichtfelder)</p>
  </div>

  <div class="form-buttons">
    <button
      pButton
      label=""
      title="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!newCourseForm.valid"
    ></button>
    <button
      pButton
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
